export default __webpack_public_path__ + "static/media/vendredi_sur_mer_1_lowdef.3167db79.png";